module.exports = __webpack_public_path__ + "img/portf2.12456fff.png";